export default __webpack_public_path__ + "static/media/jobs-values-shape.6a11f735.svg";